import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AgmCoreModule } from '@agm/core';
import { AppComponent } from './app.component';
import { RouterModule, Routes } from '@angular/router';
import { MDBBootstrapModulesPro, ToastModule } from 'ng-uikit-pro-standard';
import { DatePipe } from '@angular/common';
import { NgxSpinnerModule } from "ngx-spinner";
import { StepsModule } from 'primeng/steps';
import { AccordionModule } from 'primeng/accordion';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToolbarModule } from 'primeng/toolbar';
import { CardModule } from 'primeng/card';
import { TabMenuModule } from 'primeng/tabmenu';
import { ChartModule } from 'primeng/chart';
import { SliderModule } from 'primeng/slider';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { MenubarModule } from 'primeng/menubar';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { AutoCompleteModule } from 'primeng/autocomplete';

// Interceptors
import { ErrorInterceptor } from './services-http/http-interceptor/error.interceptor';
import { JwtInterceptor } from './services-http/http-interceptor/jwt.interceptor';
import { AuthGuardService } from './services-http/auth-guard/auth-guard.service';

// pipes
import { TruncatePipe } from './services-pipe/truncate/truncate.pipe';
import { SearchPipe } from './services-pipe/search/search.pipe';
import { SanitizeHtmlPipe } from './services-pipe/sanitize-html/sanitize-html.pipe';
import { SanitizeUrlService} from './services-pipe/sanitize-url/sanitize-url.service';

// components
import { WelcomeComponent } from './components/welcome/welcome.component';
import { WelcomeHomeComponent } from './components/welcome-home/welcome-home.component';
import { AdminComponent } from './components/admin/admin/admin.component';
import { AdminUserManagementComponent } from './components/shared/admin-user-management/admin-user-management.component';
import { AdminUserManagementUpdateComponent } from './components/shared/admin-user-management-update/admin-user-management-update.component';
import { CoopComponent } from './components/coop/coop/coop.component';
import { ProfileViewComponent } from './components/profile-view/profile-view.component';

import { ProfileEditComponent } from './components/profile-edit/profile-edit.component';
// import { CoopProductionHistoryComponent } from './components/coop/coop-production-history/coop-production-history.component';
import { AdminProductionHistoryComponent } from './components/admin/admin-production-history/admin-production-history.component';
import { AdminContactUsComponent } from './components/shared/admin-contact-us/admin-contact-us.component';
import { AdminFeedbackComponent } from './components/shared/admin-feedback/admin-feedback.component';
import { CoopClaimsSubmissionComponent } from './components/shared/coop-claims-submission/coop-claims-submission.component';
import { CoopClaimsMonitoringComponent } from './components/shared/coop-claims-monitoring/coop-claims-monitoring.component';
import { AdminCacCoopinfoComponent } from './components/shared/admin-cac-coopinfo/admin-cac-coopinfo.component';
import { AdminCacChartComponent } from './components/shared/admin-cac-chart/admin-cac-chart.component';
import { PcrDashboardComponent } from './components/shared/pcr-dashboard/pcr-dashboard.component';
import { PcrDetailedCollectionReportComponent } from './components/shared/pcr-detailed-collection-report/pcr-detailed-collection-report.component';
import { AdminRemittanceManagementComponent } from './components/shared/admin-remittance-management/admin-remittance-management.component';
import { AdminRemittanceUploadingComponent } from './components/shared/admin-remittance-uploading/admin-remittance-uploading.component';                        
import { AdminCacCashInApprovalComponent } from './components/shared/admin-cac-cash-in-approval/admin-cac-cash-in-approval.component';
import { CoopFAQComponent } from './components/shared/coop-faq/coop-faq.component';
import { GamComponent } from './components/gam/gam/gam.component';
// import { GamProductionReportComponent } from './components/gam/gam-production-report/gam-production-report.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { CacComponent } from './components/cac/cac/cac.component';
// import { CacProductionReportComponent } from './components/cac/cac-production-report/cac-production-report.component';
import { CacProductionReportChartComponent } from './components/shared/cac-production-report-chart/cac-production-report-chart.component';
import { CacWalletComponent } from './components/shared/cac-wallet/cac-wallet.component';
import { AdminQuotationApprovalComponent } from './components/shared/admin-quotation-approval/admin-quotation-approval.component';
import { IssuedPolicyCountReportComponent } from './components/shared/issued-policy-count-report/issued-policy-count-report.component';
import { CacIssuedPolicyCountReportComponent } from './components/shared/cac-issued-policy-count-report/cac-issued-policy-count-report.component';
import { CTPLComponent } from './components/shared/CTPL/CTPL.component';
import { AdminQuotationDetailsComponent } from './components/shared/admin-quotation-details/admin-quotation-details.component';
import { IssuedPolicyComponent } from './components/shared/issued-policy/issued-policy.component';
import { SettingComponent } from './components/shared/setting/setting.component';
import { EndorsementComponent } from './components/shared/endorsement/endorsement.component';
import { ComprehensiveComponent } from './components/shared/comprehensive/comprehensive.component';
import { StandardFireComponent } from './components/shared/standard-fire/standard-fire.component';
import { IssuedPolicyQuotationComponent } from './components/shared/issued-policy-quotation/issued-policy-quotation.component';
import { CreateInsurtechAnnouncementComponent } from './components/shared/create-insurtech-announcement/create-insurtech-announcement.component';
import { FeedbackUsComponent } from './components/shared/feedback-us/feedback-us.component';
import { UpdateInsurtechVersionComponent } from './components/shared/update-insurtech-version/update-insurtech-version.component';
import { ProductManagementComponent } from './components/shared/product-management/product-management/product-management.component';
import { UnderAgentListComponent } from './components/shared/under-agent-list/under-agent-list.component';
import { CoopApiUserComponent } from './components/shared/coop-api-user/coop-api-user.component';
import { CacProductsComponent } from './components/shared/cac-products/cac-products.component';
import { UserCountComponent } from './components/shared/reports/user-count/user-count.component';
import { PolicyCountComponent } from './components/shared/reports/policy-count/policy-count.component';
import { NetpremiumSumComponent } from './components/shared/reports/netpremium-sum/netpremium-sum.component';
import { UserTransactingComponent } from './components/shared/reports/user-transacting/user-transacting.component';
import { EndorsementOfficerComponent } from './components/endorsement-officer/endorsement-officer/endorsement-officer.component';
import { DQCCenterComponent } from './components/DQC-center/dqc-center/dqc-center.component';
import { QuotationApprovalOfficerComponent } from './components/quotation-approval-officer/quotation-approval-officer/quotation-approval-officer.component';
import { CashinApprovalOfficerComponent } from './components/cashin-approval-officer/cashin-approval-officer/cashin-approval-officer.component';
import { ClaimsOfficerComponent } from './components/claims-officer/claims-officer/claims-officer.component';
import { UserManagementOfficerComponent } from './components/user-management-officer/user-management-officer/user-management-officer.component';
import { AgentComponent } from './components/agent/agent/agent.component';
import { RenewalNoticeListComponent } from './components/shared/renewal-notice-list/renewal-notice-list.component';
import { RenewalNoticeOfficerComponent } from './components/renewal-notice-officer/renewal-notice-officer/renewal-notice-officer/renewal-notice-officer.component';
import { BillingComponent } from './components/shared/billing-wallet/billing.component';
import { CreditLineApprovalComponent } from './components/shared/credit-line-appoval/credit-line-approval/credit-line-approval.component';
import { FireInsureComponent } from './components/shared/fire-insure/fire-insure.component';
import { PolicyExtensionComponent } from './components/shared/policy-extension/policy-extension.component';
import { HomepageComponent } from './components/shared/homepage/homepage.component';
import { CashierComponent  } from './components/cashier/cashier/cashier.component';
import { CheckPointsComponent } from './components/shared/check-points/check-points.component';
import { AboveRetentionLimitComponent } from './components/shared/above-retention-limit/above-retention-limit.component';
// import { AgentProductionHistoryComponent } from './components/agent/agent-production-history/agent-production-history.component';
import { BillingPaymentHistoryComponent } from './components/shared/billing-payment-history/billing-payment-history.component';
import { BillingGenerateComponent } from './components/shared/billing-generate/billing-generate.component';
import { AdminUserCommissionComponent } from './components/shared/admin-user-commission/admin-user-commission.component';
import { BranchReportsComponent } from './components/shared/branch-reports/branch-reports.component';
import { CreditPaymentApprovalComponent } from './components/shared/credit-payment-approval/credit-payment-approval.component';
import { IbisaForecastComponent } from './components/shared/ibisa-forecast/ibisa-forecast.component';
import { ReportsComponent } from './components/reports/reports.component';
import { OrIssuanceComponent } from './components/shared/or-issuance/or-issuance.component';
import { ReporterComponent } from './components/reporter/reporter/reporter.component';
import { ProductionHistoryComponent } from './components/reporter/production-history/production-history.component';
import { AdminTransactionHistoryComponent } from './components/shared/admin-transaction-history/admin-transaction-history.component';
import { SurityBondComponent } from './components/shared/surity-bond/surity-bond.component';
import { GroupAccessComponent } from './components/shared/group-access/group-access.component';
import { MigrationToNonlifeComponent } from './components/shared/migration-to-nonlife/migration-to-nonlife.component';
import { WalletBalancePerUserComponent } from './components/shared/wallet-balance-per-user/wallet-balance-per-user.component';
import { MasterPolicyComponent } from './components/shared/master-policy/master-policy.component';
import { ChatboxComponent } from './components/shared/chatbox/chatbox.component';
import { TimeAgoPipe } from './services-pipe/timeAgo/time-ago.pipe';
import { UpdateProfileComponent } from './components/shared/update-profile/update-profile.component';
import { CreateAccountComponent } from './components/shared/create-account/create-account.component';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ForgotPasswordComponent } from './components/shared/forgot-password/forgot-password.component';
import { NotificationPopoverComponent } from './components/shared/notification-popover/notification-popover.component';
import { CreateProductComponent } from './components/shared/create-product/create-product/create-product.component';
import { CommaFormatDirective } from './services-pipe/commaFormat/comma-format.directive';
import { MotorbancaComponent } from './components/shared/motorbanca/motorbanca/motorbanca.component';
import { CancellationNoticeComponent } from './components/shared/cancellation-notice/cancellation-notice.component';
import { CGLComponent } from './components/shared/cgl/cgl.component';
import { GroupPersonalAccidentCustomizedComponent } from './components/shared/group-personal-accident-customized/group-personal-accident-customized.component';
import { TakafulComponent } from './components/takaful/takaful/takaful.component';
import { ManagerhomeComponent } from './components/manager/managerhome/managerhome.component';
import { ClimbsOfficeHomeComponent } from './components/climbs-office/climbs-office-home/climbs-office-home.component';
import { ProductionReportComponent } from './components/shared/production-report/production-report.component';
import { ComprehensiveTakafulComponent } from './components/shared/comprehensive-takaful/comprehensive-takaful.component';
import { GitInsuredComponent } from './components/shared/git-insured/git-insured.component';



const appRoutes: Routes = [
  {
    path: 'Manager',
    component: ManagerhomeComponent,
    canActivate: [AuthGuardService],
    data: { userType: 17 },
    children: [
      { path: 'homepage', component: HomepageComponent },
      { path: 'FAQ', component: CoopFAQComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'profile/:id/view', component: ProfileViewComponent },
      { path: 'production-history', component: AdminProductionHistoryComponent },
      { path: 'quotation-approval', component: AdminQuotationApprovalComponent },
      { path: 'Cash-In-Approval', component: AdminCacCashInApprovalComponent },
      { path: 'credit-payment', component: CreditPaymentApprovalComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'chatbox', component: ChatboxComponent },
      { path: 'coop-contact-us', component: AdminContactUsComponent },
      { path: 'above-retention-limit', component: AboveRetentionLimitComponent },
      { path: 'endorsement', component: EndorsementComponent },
      { path: 'fire-issue/:id/quoteId/:quoteId/:login_id', component: FireInsureComponent },
      { path: 'comprehensive/:id/quoteId/:quoteId/:login_id', component: ComprehensiveComponent },
      { path: 'standard-fire/quoteId/:quoteId/:login_id', component: StandardFireComponent },
      { path: 'CAC-products/:id/quoteId/:quoteId/:login_id', component: CacProductsComponent },

    ]
  },
  {
    path: 'CLIMBS-Office',
    component: ClimbsOfficeHomeComponent,
    canActivate: [AuthGuardService],
    data: { userType: 18 },
    children: [
      { path: 'homepage', component: HomepageComponent },
      { path: 'FAQ', component: CoopFAQComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'profile/:id/view', component: ProfileViewComponent },
      { path: 'production-history', component: AdminProductionHistoryComponent },
      { path: 'quotation-approval', component: AdminQuotationApprovalComponent },
      { path: 'Cash-In-Approval', component: AdminCacCashInApprovalComponent },
      { path: 'credit-payment', component: CreditPaymentApprovalComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'chatbox', component: ChatboxComponent },
      { path: 'coop-contact-us', component: AdminContactUsComponent },
      { path: 'policy-issued', component: IssuedPolicyComponent },
      { path: 'issued-policy-quotation', component: IssuedPolicyQuotationComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'claims-monitoring', component: CoopClaimsMonitoringComponent },
      { path: 'user-commission/:code/type/:type', component: AdminUserCommissionComponent },
      { path: 'endorsement', component: EndorsementComponent },
      { path: 'comprehensive/:id/quoteId/:quoteId/:login_id', component: ComprehensiveComponent },
      { path: 'standard-fire/quoteId/:quoteId/:login_id', component: StandardFireComponent },
      { path: 'fire-issue/:id/quoteId/:quoteId/:login_id', component: FireInsureComponent },
      { path: 'CAC-products/:id/quoteId/:quoteId/:login_id', component: CacProductsComponent },
      { path: 'motorbanca/:id/quoteId/:quoteId/:login_id', component: MotorbancaComponent },
      { path: 'surity-bond/:id/quoteId/:quoteId/:login_id', component: SurityBondComponent },
      { path: 'billing', component: BillingComponent },
      { path: 'billing-payment-history', component: BillingPaymentHistoryComponent },
      { path: 'billing-generate', component: BillingGenerateComponent },
      { path: 'coop-wallet', component: CacWalletComponent },
      { path: 'get-insured/:producType', component: GitInsuredComponent },
    ]
  },
  {
    path: 'Takaful',
    component: TakafulComponent,
    canActivate: [AuthGuardService],
    data: { userType: 16 },
    children: [
      { path: 'homepage', component: HomepageComponent },
      { path: 'Takaful-FAQ', component: CoopFAQComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'cac-profile/:id/view', component: ProfileViewComponent },
      { path: 'comprehensive/:id/quoteId/:quoteId/:login_id', component: ComprehensiveComponent },
      { path: 'issued-policy-quotation', component: IssuedPolicyQuotationComponent },
      { path: 'coop-production-history', component: ProductionReportComponent },
      { path: 'admin-claims-monitoring', component: CoopClaimsMonitoringComponent },
      { path: 'production-report', component: ProductionReportComponent },
      { path: 'policy-issued', component: IssuedPolicyComponent },
      { path: 'endorsement', component: EndorsementComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'profileEdit', component: ProfileEditComponent },
    ]
  },
  {
    path: 'reporter',
    component: ReporterComponent,
    canActivate: [AuthGuardService],
    data: { userType: 15 },
    children: [
      { path: 'homepage', component: HomepageComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'profile/:id/view', component: ProfileViewComponent },
      { path: 'profileEdit', component: ProfileEditComponent },
      { path: 'production-history', component: ProductionHistoryComponent },
      { path: 'FAQ', component: CoopFAQComponent },
      { path: 'endorsement', component: EndorsementComponent },
      { path: 'adminRemittance', component: AdminRemittanceManagementComponent },
      { path: 'renewal-notice-list', component: RenewalNoticeListComponent },
      { path: 'user-commission/:code/type/:type', component: AdminUserCommissionComponent },
      { path: 'under-agent-list', component: UnderAgentListComponent },
      { path: 'billing-payment-history', component: BillingPaymentHistoryComponent },
      { path: 'billing-generate', component: BillingGenerateComponent },
      { path: 'billing', component: BillingComponent },
      { path: 'gam-wallet', component: CacWalletComponent },
      { path: 'chatbox', component: ChatboxComponent }
    ]
  },

  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AuthGuardService],
    data: { userType: 1 },
    children: [
      { path: 'master-policy', component: MasterPolicyComponent },
      { path: 'orIssuance', component: OrIssuanceComponent },
      { path: 'users', component: AdminUserManagementComponent },
      { path: 'users/:id/update', component: AdminUserManagementUpdateComponent },
      { path: 'profile/:id/view', component: ProfileViewComponent },
      { path: 'profileEdit', component: ProfileEditComponent },
      { path: 'agent-feedback', component: AdminFeedbackComponent },
      { path: 'production-history', component: AdminProductionHistoryComponent },
      { path: 'cac-coopinfo', component: AdminCacCoopinfoComponent },
      { path: 'cac-chart', component: AdminCacChartComponent },
      { path: 'pcr-dashboard', component: PcrDashboardComponent },
      { path: 'pcr-detailed-report-recon', component: PcrDetailedCollectionReportComponent },
      { path: 'Cash-In-Approval', component: AdminCacCashInApprovalComponent },
      { path: 'quotation-approval', component: AdminQuotationApprovalComponent },
      { path: 'isued-policy-summary', component: IssuedPolicyCountReportComponent },
      { path: 'quotation-details/:id', component: AdminQuotationDetailsComponent },
      { path: 'endorsement', component: EndorsementComponent },
      { path: 'adminRemittance', component: AdminRemittanceManagementComponent },
      { path: 'admin-remittance-uploading', component: AdminRemittanceUploadingComponent },
      { path: 'create-insurtech-announcement', component: CreateInsurtechAnnouncementComponent },
      { path: 'update-insurtech-version', component: UpdateInsurtechVersionComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'productManagement', component: ProductManagementComponent },
      { path: 'coop-api-user', component: CoopApiUserComponent },
      { path: 'user-count-report', component: UserCountComponent },
      { path: 'policy-count-report', component: PolicyCountComponent },
      { path: 'sum-net-premium', component: NetpremiumSumComponent },
      { path: 'user-transacting', component: UserTransactingComponent },
      { path: 'admin-claims-monitoring', component: CoopClaimsMonitoringComponent },
      { path: 'renewal-notice-list', component: RenewalNoticeListComponent },
      { path: 'credit-line', component: CreditLineApprovalComponent },
      { path: 'homepage', component: HomepageComponent },
      { path: 'check-points', component: CheckPointsComponent },
      { path: 'above-retention-limit', component: AboveRetentionLimitComponent },
      { path: 'user-commission/:code', component: AdminUserCommissionComponent },
      { path: 'credit-payment', component: CreditPaymentApprovalComponent },
      { path: 'admin-billing-payment', component: BillingGenerateComponent },
      { path: 'ibisa-forecast', component: IbisaForecastComponent },
      { path: 'admin-transaction-history', component: AdminTransactionHistoryComponent },
      { path: 'fire-issue/:id/quoteId/:quoteId/:login_id', component: FireInsureComponent },
      { path: 'comprehensive/:id/quoteId/:quoteId/:login_id', component: ComprehensiveComponent },
      { path: 'standard-fire/quoteId/:quoteId/:login_id', component: StandardFireComponent },
      { path: 'CAC-products/:id/quoteId/:quoteId/:login_id', component: CacProductsComponent },
      { path: 'group-access', component: GroupAccessComponent },
      { path: 'migrate-to-nonlife', component: MigrationToNonlifeComponent },
      { path: 'wallet-balance-per-user', component: WalletBalancePerUserComponent },
      { path: 'chatbox', component: ChatboxComponent },
      { path: 'create-product/:variantid', component: CreateProductComponent }
    ]
  },


  {
    path: 'coop',
    component: CoopComponent,
    canActivate: [AuthGuardService],
    data: { userType: 6 },
    children: [
      { path: 'profile/:id/view', component: ProfileViewComponent },
      { path: 'coop-production-history', component: ProductionReportComponent },
      { path: 'coop-contact-us', component: AdminContactUsComponent },
      { path: 'coop-claims-submission', component: CoopClaimsSubmissionComponent },
      { path: 'coop-claims-monitoring', component: CoopClaimsMonitoringComponent },
      { path: 'coop-cac-chart', component: CacProductionReportChartComponent },
      { path: 'coop-wallet', component: CacWalletComponent },
      { path: 'FAQ', component: CoopFAQComponent },
      { path: 'coop-quotation-issued-policy-count-report', component: CacIssuedPolicyCountReportComponent },
      { path: 'policy-issuance/quoteId/:quoteId/:login_id', component: CTPLComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'policy-issued', component: IssuedPolicyComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'comprehensive/:id/quoteId/:quoteId/:login_id', component: ComprehensiveComponent },
      { path: 'standard-fire/quoteId/:quoteId/:login_id', component: StandardFireComponent },
      { path: 'issued-policy-quotation', component: IssuedPolicyQuotationComponent },
      { path: 'admin-remittance-uploading', component: AdminRemittanceUploadingComponent },
      { path: 'adminRemittance', component: AdminRemittanceManagementComponent },
      { path: 'renewal-notice-list', component: RenewalNoticeListComponent },
      { path: 'endorsement', component: EndorsementComponent },
      { path: 'billing', component: BillingComponent },
      { path: 'under-agent-list', component: UnderAgentListComponent },
      { path: 'policy-extension', component: PolicyExtensionComponent },
      { path: 'homepage', component: HomepageComponent },
      { path: 'billing-payment-history', component: BillingPaymentHistoryComponent },
      { path: 'billing-generate', component: BillingGenerateComponent },
      { path: 'user-commission/:code/type/:type', component: AdminUserCommissionComponent },
      { path: 'ibisa-forecast', component: IbisaForecastComponent },
      { path: 'fire-issue/:id/quoteId/:quoteId/:login_id', component: FireInsureComponent },
      { path: 'CAC-products/:id/quoteId/:quoteId/:login_id', component: CacProductsComponent },
      { path: 'chatbox', component: ChatboxComponent },
      { path: 'motorbanca/:id/quoteId/:quoteId/:login_id', component: MotorbancaComponent },
      { path: 'surity-bond/:id/quoteId/:quoteId/:login_id', component: SurityBondComponent },
      { path: 'comprehensive-takaful/:id/quoteId/:quoteId/:login_id', component: ComprehensiveTakafulComponent },
      { path: 'get-insured/:producType', component: GitInsuredComponent },
    ]
  },


  {
    path: 'gam',
    component: GamComponent,
    canActivate: [AuthGuardService],
    data: { userType: 3 },
    children: [
      { path: 'gam-FAQ', component: CoopFAQComponent },
      { path: 'gam-Contact-us', component: AdminContactUsComponent },
      { path: 'gam-wallet', component: CacWalletComponent },
      { path: 'gam-profile/:id/view', component: ProfileViewComponent },
      { path: 'gam-production-report', component: ProductionReportComponent },
      { path: 'gam-production-report-chart', component: CacProductionReportChartComponent },
      { path: 'gam-quotation-issued-policy-count-report', component: CacIssuedPolicyCountReportComponent },
      { path: 'policy-issuance/quoteId/:quoteId/:login_id', component: CTPLComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'policy-issued', component: IssuedPolicyComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'issued-policy-quotation', component: IssuedPolicyQuotationComponent },
      { path: 'comprehensive/:id/quoteId/:quoteId/:login_id', component: ComprehensiveComponent },
      { path: 'standard-fire/quoteId/:quoteId/:login_id', component: StandardFireComponent },
      { path: 'admin-remittance-uploading', component: AdminRemittanceUploadingComponent },
      { path: 'adminRemittance', component: AdminRemittanceManagementComponent },
      { path: 'coop-claims-submission', component: CoopClaimsSubmissionComponent },
      { path: 'coop-claims-monitoring', component: CoopClaimsMonitoringComponent },
      { path: 'renewal-notice-list', component: RenewalNoticeListComponent },
      { path: 'endorsement', component: EndorsementComponent },
      { path: 'billing', component: BillingComponent },
      { path: 'under-agent-list', component: UnderAgentListComponent },
      { path: 'policy-extension', component: PolicyExtensionComponent },
      { path: 'homepage', component: HomepageComponent },
      { path: 'user-commission/:code/type/:type', component: AdminUserCommissionComponent },
      { path: 'ibisa-forecast', component: IbisaForecastComponent },
      { path: 'fire-issue/:id/quoteId/:quoteId/:login_id', component: FireInsureComponent },
      { path: 'CAC-products/:id/quoteId/:quoteId/:login_id', component: CacProductsComponent },
      { path: 'chatbox', component: ChatboxComponent },
      { path: 'motorbanca/:id/quoteId/:quoteId/:login_id', component: MotorbancaComponent },
      { path: 'surity-bond/:id/quoteId/:quoteId/:login_id', component: SurityBondComponent },
      { path: 'comprehensive-takaful/:id/quoteId/:quoteId/:login_id', component: ComprehensiveTakafulComponent },
      { path: 'get-insured/:producType', component: GitInsuredComponent },
    ]
  },


  {
    path: 'cac',
    component: CacComponent,
    canActivate: [AuthGuardService],
    data: { userType: 4 },
    children: [
      { path: 'cac-FAQ', component: CoopFAQComponent },
      { path: 'cac-Contact-us', component: AdminContactUsComponent },
      { path: 'cac-wallet', component: CacWalletComponent },
      { path: 'cac-profile/:id/view', component: ProfileViewComponent },
      { path: 'cac-production-report', component: ProductionReportComponent },
      // { path: 'production-report', component: ProductionReportComponent },
      { path: 'cac-production-report-chart', component: CacProductionReportChartComponent },
      { path: 'cac-quotation-issued-policy-count-report', component: CacIssuedPolicyCountReportComponent },
      { path: 'policy-issuance/quoteId/:quoteId/:login_id', component: CTPLComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'policy-issued', component: IssuedPolicyComponent },
      { path: 'admin-remittance-uploading', component: AdminRemittanceUploadingComponent },
      { path: 'adminRemittance', component: AdminRemittanceManagementComponent },
      { path: 'issued-policy-quotation', component: IssuedPolicyQuotationComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'under-agent-list', component: UnderAgentListComponent },
      { path: 'CAC-products/:id/quoteId/:quoteId/:login_id', component: CacProductsComponent },
      { path: 'coop-claims-submission', component: CoopClaimsSubmissionComponent },
      { path: 'coop-claims-monitoring', component: CoopClaimsMonitoringComponent },
      { path: 'billing', component: BillingComponent },
      { path: 'renewal-notice-list', component: RenewalNoticeListComponent },
      { path: 'endorsement', component: EndorsementComponent },
      { path: 'comprehensive/:id/quoteId/:quoteId/:login_id', component: ComprehensiveComponent },
      { path: 'standard-fire/quoteId/:quoteId/:login_id', component: StandardFireComponent },
      { path: 'policy-extension', component: PolicyExtensionComponent },
      { path: 'homepage', component: HomepageComponent },
      { path: 'billing-payment-history', component: BillingPaymentHistoryComponent },
      { path: 'billing-generate', component: BillingGenerateComponent },
      { path: 'user-commission/:code/type/:type', component: AdminUserCommissionComponent },
      { path: 'ibisa-forecast', component: IbisaForecastComponent },
      { path: 'fire-issue/:id/quoteId/:quoteId/:login_id', component: FireInsureComponent },
      { path: 'surity-bond/:id/quoteId/:quoteId/:login_id', component: SurityBondComponent },
      { path: 'chatbox', component: ChatboxComponent },
      { path: 'motorbanca/:id/quoteId/:quoteId/:login_id', component: MotorbancaComponent },
      { path: 'cancellation-notice', component: CancellationNoticeComponent },
      { path: 'cgl/:id/quoteId/:quoteId/:login_id', component: CGLComponent },
      { path: 'group-customized', component: GroupPersonalAccidentCustomizedComponent },
      { path: 'comprehensive-takaful/:id/quoteId/:quoteId/:login_id', component: ComprehensiveTakafulComponent },
      { path: 'get-insured/:producType', component: GitInsuredComponent },
    ]
  },


  {
    path: 'agent',
    component: AgentComponent,
    canActivate: [AuthGuardService],
    data: { userType: 5 },
    children: [
      { path: 'cac-FAQ', component: CoopFAQComponent },
      { path: 'cac-Contact-us', component: AdminContactUsComponent },
      { path: 'cac-wallet', component: CacWalletComponent },
      { path: 'cac-profile/:id/view', component: ProfileViewComponent },
      { path: 'agent-production-report', component: ProductionReportComponent },
      { path: 'cac-production-report-chart', component: CacProductionReportChartComponent },
      { path: 'cac-quotation-issued-policy-count-report', component: CacIssuedPolicyCountReportComponent },
      { path: 'policy-issuance/quoteId/:quoteId/:login_id', component: CTPLComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'policy-issued', component: IssuedPolicyComponent },
      { path: 'comprehensive/:id/quoteId/:quoteId/:login_id', component: ComprehensiveComponent },
      { path: 'standard-fire/quoteId/:quoteId/:login_id', component: StandardFireComponent },
      { path: 'issued-policy-quotation', component: IssuedPolicyQuotationComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'CAC-products/:id/quoteId/:quoteId/:login_id', component: CacProductsComponent },
      { path: 'coop-claims-submission', component: CoopClaimsSubmissionComponent },
      { path: 'coop-claims-monitoring', component: CoopClaimsMonitoringComponent },
      { path: 'admin-remittance-uploading', component: AdminRemittanceUploadingComponent },
      { path: 'adminRemittance', component: AdminRemittanceManagementComponent },
      { path: 'policy-extension', component: PolicyExtensionComponent },
      { path: 'homepage', component: HomepageComponent },
      { path: 'billing', component: BillingComponent },
      { path: 'fire-issue/:id/quoteId/:quoteId/:login_id', component: FireInsureComponent },
      { path: 'endorsement', component: EndorsementComponent },
      { path: 'billing-payment-history', component: BillingPaymentHistoryComponent },
      { path: 'billing-generate', component: BillingGenerateComponent },
      { path: 'user-commission/:code/type/:type', component: AdminUserCommissionComponent },
      { path: 'ibisa-forecast', component: IbisaForecastComponent },
      { path: 'chatbox', component: ChatboxComponent },
      { path: 'motorbanca/:id/quoteId/:quoteId/:login_id', component: MotorbancaComponent },
      { path: 'surity-bond/:id/quoteId/:quoteId/:login_id', component: SurityBondComponent },
      { path: 'comprehensive-takaful/:id/quoteId/:quoteId/:login_id', component: ComprehensiveTakafulComponent },
      { path: 'get-insured/:producType', component: GitInsuredComponent },
    ]
  },


  {
    path: 'renewalOfficer',
    component: RenewalNoticeOfficerComponent,
    canActivate: [AuthGuardService],
    data: { userType: 13 },
    children: [
      { path: 'renewal-notice-list', component: RenewalNoticeListComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'cac-Contact-us', component: AdminContactUsComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'profile/:id/view', component: ProfileViewComponent },
      { path: 'homepage', component: HomepageComponent },
      { path: 'ibisa-forecast', component: IbisaForecastComponent },
      { path: 'chatbox', component: ChatboxComponent }
    ]
  },


  {
    path: 'cashier',
    component: CashierComponent,
    canActivate: [AuthGuardService],
    data: { userType: 14 },
    children: [
      { path: 'adminRemittance', component: AdminRemittanceManagementComponent },
      { path: 'admin-remittance-uploading', component: AdminRemittanceUploadingComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'cac-Contact-us', component: AdminContactUsComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'cac-profile/:id/view', component: ProfileViewComponent },
      { path: 'homepage', component: HomepageComponent },
      { path: 'ibisa-forecast', component: IbisaForecastComponent },
      { path: 'chatbox', component: ChatboxComponent },
      { path: 'Cash-In-Approval', component: AdminCacCashInApprovalComponent },
      { path: 'credit-payment', component: CreditPaymentApprovalComponent },
      { path: 'production-history', component: AdminProductionHistoryComponent },
      { path: 'endorsement', component: EndorsementComponent },
      { path: 'billing-payment', component: BillingGenerateComponent },
      { path: 'orIssuance', component: OrIssuanceComponent },
      { path: 'admin-transaction-history', component: AdminTransactionHistoryComponent },
      { path: 'wallet-balance-per-user', component: WalletBalancePerUserComponent }
    ]
  },


  {
    path: 'endorsement-officer',
    component: EndorsementOfficerComponent,
    canActivate: [AuthGuardService],
    data: { userType: 7 },
    children: [
      { path: 'endorsement', component: EndorsementComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'cac-Contact-us', component: AdminContactUsComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'cac-profile/:id/view', component: ProfileViewComponent },
      { path: 'homepage', component: HomepageComponent },
      { path: 'ibisa-forecast', component: IbisaForecastComponent },
      { path: 'chatbox', component: ChatboxComponent }
    ]
  },


  {
    path: 'DQC-officer',
    component: DQCCenterComponent,
    canActivate: [AuthGuardService],
    data: { userType: 8 },
    children: [
      { path: 'adminRemittance', component: AdminRemittanceManagementComponent },
      { path: 'admin-remittance-uploading', component: AdminRemittanceUploadingComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'cac-Contact-us', component: AdminContactUsComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'cac-profile/:id/view', component: ProfileViewComponent },
      { path: 'homepage', component: HomepageComponent },
      { path: 'ibisa-forecast', component: IbisaForecastComponent },
      { path: 'chatbox', component: ChatboxComponent }
    ]
  },


  {
    path: 'quotation-approval-officer',
    component: QuotationApprovalOfficerComponent,
    canActivate: [AuthGuardService],
    data: { userType: 9 },
    children: [
      { path: 'quotation-approval', component: AdminQuotationApprovalComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'cac-Contact-us', component: AdminContactUsComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'cac-profile/:id/view', component: ProfileViewComponent },
      { path: 'quotation-details/:id', component: AdminQuotationDetailsComponent },
      { path: 'homepage', component: HomepageComponent },
      { path: 'ibisa-forecast', component: IbisaForecastComponent },
      { path: 'fire-issue/:id/quoteId/:quoteId/:login_id', component: FireInsureComponent },
      { path: 'comprehensive/:id/quoteId/:quoteId/:login_id', component: ComprehensiveComponent },
      { path: 'standard-fire/quoteId/:quoteId/:login_id', component: StandardFireComponent },
      { path: 'CAC-products/:id/quoteId/:quoteId/:login_id', component: CacProductsComponent },
      { path: 'chatbox', component: ChatboxComponent }
    ]
  },


  {
    path: 'cashin-approval-officer',
    component: CashinApprovalOfficerComponent,
    canActivate: [AuthGuardService],
    data: { userType: 10 },
    children: [
      { path: 'Cash-In-Approval', component: AdminCacCashInApprovalComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'cac-Contact-us', component: AdminContactUsComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'cac-profile/:id/view', component: ProfileViewComponent },
      { path: 'credit-line', component: CreditLineApprovalComponent },
      { path: 'homepage', component: HomepageComponent },
      { path: 'check-points', component: CheckPointsComponent },
      { path: 'credit-payment', component: CreditPaymentApprovalComponent },
      { path: 'billing-payment', component: BillingGenerateComponent },
      { path: 'production-history', component: AdminProductionHistoryComponent },
      { path: 'users', component: AdminUserManagementComponent },
      { path: 'ibisa-forecast', component: IbisaForecastComponent },
      { path: 'orIssuance', component: OrIssuanceComponent },
      { path: 'admin-transaction-history', component: AdminTransactionHistoryComponent },
      { path: 'wallet-balance-per-user', component: WalletBalancePerUserComponent },
      { path: 'endorsement', component: EndorsementComponent },
      { path: 'chatbox', component: ChatboxComponent }
    ]
  },


  {
    path: 'claims-officer',
    component: ClaimsOfficerComponent,
    canActivate: [AuthGuardService],
    data: { userType: 11 },
    children: [
      { path: 'admin-claims-monitoring', component: CoopClaimsMonitoringComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'cac-Contact-us', component: AdminContactUsComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'cac-profile/:id/view', component: ProfileViewComponent },
      { path: 'homepage', component: HomepageComponent },
      { path: 'ibisa-forecast', component: IbisaForecastComponent },
      { path: 'chatbox', component: ChatboxComponent }
    ]
  },


  {
    path: 'user-management-officer',
    component: UserManagementOfficerComponent,
    canActivate: [AuthGuardService],
    data: { userType: 12 },
    children: [
      { path: 'users', component: AdminUserManagementComponent },
      { path: 'coop-api-user', component: CoopApiUserComponent },
      { path: 'feedback-us', component: FeedbackUsComponent },
      { path: 'cac-Contact-us', component: AdminContactUsComponent },
      { path: 'setting', component: SettingComponent },
      { path: 'cac-profile/:id/view', component: ProfileViewComponent },
      { path: 'users/:id/update', component: AdminUserManagementUpdateComponent },
      { path: 'homepage', component: HomepageComponent },
      { path: 'ibisa-forecast', component: IbisaForecastComponent },
      { path: 'user-commission/:code', component: AdminUserCommissionComponent },
      { path: 'chatbox', component: ChatboxComponent }
    ]
  },


  {
    path: 'report',
    component: ReportsComponent,
    children: [
      { path: 'policy-count-report', component: PolicyCountComponent },
      { path: 'Cash-In-Approval', component: AdminCacCashInApprovalComponent },
      { path: 'credit-payment', component: CreditPaymentApprovalComponent },
      { path: 'user-transacting', component: UserTransactingComponent },
      { path: 'sum-net-premium', component: NetpremiumSumComponent },
      { path: 'user-count-report', component: UserCountComponent },
      { path: 'isued-policy-summary', component: IssuedPolicyCountReportComponent },
      { path: 'ibisa-forecast', component: IbisaForecastComponent },
      { path: 'production-history', component: AdminProductionHistoryComponent },
      { path: 'adminRemittance', component: AdminRemittanceManagementComponent }
    ]
  },


  {
    path: 'welcome',
    component: WelcomeComponent,
    children: [
      { path: 'home', component: WelcomeHomeComponent },
      { path: 'update-profile', component: UpdateProfileComponent },
      { path: 'create-account', component: CreateAccountComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent }
    ]
  },

  // Default and fallback
  { path: '', redirectTo: '/welcome/home', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent },
  { path: 'page-not-found', component: PageNotFoundComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    WelcomeHomeComponent,
    AdminComponent,
    AdminUserManagementComponent,
    SearchPipe,
    AdminUserManagementUpdateComponent,
    CoopComponent,
    ProfileViewComponent,
    SanitizeHtmlPipe,
    TruncatePipe,
    ProfileEditComponent,
    AdminRemittanceManagementComponent,
    // CoopProductionHistoryComponent,
    AdminProductionHistoryComponent,
    AdminContactUsComponent,
    AdminFeedbackComponent,
    CoopClaimsSubmissionComponent,
    CoopClaimsMonitoringComponent,
    AdminCacCoopinfoComponent,
    AdminCacChartComponent,
    PcrDashboardComponent,
    PcrDetailedCollectionReportComponent,
    AdminRemittanceUploadingComponent,
    AdminCacCashInApprovalComponent,
    CoopFAQComponent,
    GamComponent,
    // GamProductionReportComponent,
    PageNotFoundComponent,
    CacComponent,
    // CacProductionReportComponent,
    CacProductionReportChartComponent,
    CacWalletComponent,
    AdminQuotationApprovalComponent,
    IssuedPolicyCountReportComponent,
    CacIssuedPolicyCountReportComponent,
    CTPLComponent,
    AdminQuotationDetailsComponent,
    IssuedPolicyComponent,
    SettingComponent,
    EndorsementComponent,
    ComprehensiveComponent,
    StandardFireComponent,
    IssuedPolicyQuotationComponent,
    CreateInsurtechAnnouncementComponent,
    FeedbackUsComponent,
    UpdateInsurtechVersionComponent,
    ProductManagementComponent,
    UnderAgentListComponent,
    CoopApiUserComponent,
    CacProductsComponent,
    UserCountComponent,
    UserCountComponent,
    PolicyCountComponent,
    NetpremiumSumComponent,
    UserTransactingComponent,
    EndorsementOfficerComponent,
    DQCCenterComponent,
    QuotationApprovalOfficerComponent,
    CashinApprovalOfficerComponent,
    ClaimsOfficerComponent,
    UserManagementOfficerComponent,
    AgentComponent,
    RenewalNoticeListComponent,
    RenewalNoticeOfficerComponent,
    BillingComponent,
    CreditLineApprovalComponent,
    FireInsureComponent,
    PolicyExtensionComponent,
    HomepageComponent,
    CashierComponent,
    CheckPointsComponent,
    AboveRetentionLimitComponent,
    SanitizeUrlService,
    // AgentProductionHistoryComponent,
    BillingPaymentHistoryComponent,
    BillingGenerateComponent,
    AdminUserCommissionComponent,
    BranchReportsComponent,
    CreditPaymentApprovalComponent,
    IbisaForecastComponent,
    ReportsComponent,
    OrIssuanceComponent,
    ReporterComponent,
    ProductionHistoryComponent,
    AdminTransactionHistoryComponent,
    SurityBondComponent,
    GroupAccessComponent,
    MigrationToNonlifeComponent,
    WalletBalancePerUserComponent,
    MasterPolicyComponent,
    ChatboxComponent,
    TimeAgoPipe,
    UpdateProfileComponent,
    CreateAccountComponent,
    ForgotPasswordComponent,
    NotificationPopoverComponent,
    CreateProductComponent,
    CommaFormatDirective,
    MotorbancaComponent,
    CancellationNoticeComponent,
    CGLComponent,
    GroupPersonalAccidentCustomizedComponent,
    TakafulComponent,
    ManagerhomeComponent,
    ClimbsOfficeHomeComponent,
    ProductionReportComponent,
    ComprehensiveTakafulComponent,
    GitInsuredComponent,
 
   ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule, 
    FormsModule,
    HttpClientModule,
    ToastModule.forRoot(),
    MDBBootstrapModulesPro.forRoot(),
    AgmCoreModule.forRoot({
      // https://developers.google.com/maps/documentation/javascript/get-api-key?hl=en#key
      apiKey: 'Your_api_key',
    }),
    RouterModule.forRoot(
      appRoutes, 
      {
        enableTracing: false, // <-- debugging purposes only
        useHash: true,
      }
    ),
    ReactiveFormsModule,
    NgxSpinnerModule,
    StepsModule,
    AccordionModule,
    ButtonModule,
    SelectButtonModule,
    ToolbarModule,
    CardModule,
    TabMenuModule,
    ChartModule,
    SliderModule,
    PaginatorModule,
    TableModule,
    MenubarModule,
    DropdownModule,
    CalendarModule,
    AutoCompleteModule,
    MatInputModule, 
    MatAutocompleteModule, 
    MatFormFieldModule

  ],
  providers: [
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ],
  bootstrap:      [ AppComponent ],
  schemas:        [ NO_ERRORS_SCHEMA ],
  entryComponents:[

  ],
})
export class AppModule { }
